import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import CFormSelectUrut from '@/components/CFormSelectUrut'
import { iconsSet as icons } from '@/assets/icons'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'
import swal from 'sweetalert'
import axios from 'axios'
import { loadPengaturan } from '@/utils/pengaturan'
import { loadMenuAkses } from '@/utils/menuAkses'
import { siapkanBranding } from '@/utils/branding'
import { getToken as getAuthToken, hapusSesi } from '@/utils/auth'

// Token login di setiap request; backend menentukan user, role, dan gudang dari token ini.
// scope_user_id hanya dipakai backend bila autentikasi dimatikan (saklar darurat).
axios.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) config.headers['X-Auth-Token'] = token

  const idUser = localStorage.getItem('id_user')
  if (!idUser || (config.method || '').toLowerCase() !== 'post') return config
  const data = config.data
  if (data instanceof FormData || data instanceof URLSearchParams) {
    data.set('scope_user_id', idUser)
  } else if (data == null || (typeof data === 'object' && !Array.isArray(data))) {
    config.data = { ...(data || {}), scope_user_id: idUser }
  }
  return config
})

// Sesi berakhir (401) -> kembali ke login; akses ditolak (403) -> beri tahu user
let sesiBerakhir = false
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const pesan = error.response?.data?.message
    if (status === 401 && error.response?.data?.code === 'AUTH' && !sesiBerakhir) {
      sesiBerakhir = true
      hapusSesi()
      // Halaman publik (QR kartu nama, verifikasi payslip) tetap tampil walau sesi lama di browser sudah habis
      if (router.resolve(window.location.hash.slice(1) || '/').meta.public) return Promise.reject(error)
      swal({ title: 'Sesi berakhir', text: pesan || 'Silakan login ulang.', icon: 'info' }).then(() => {
        window.location.hash = '#/pages/login'
        window.location.reload()
      })
    } else if (status === 403) {
      swal({ title: 'Akses ditolak', text: pesan || 'Anda tidak berhak mengakses data ini.', icon: 'error' })
    }
    return Promise.reject(error)
  },
)

const app = createApp(App)
app.use(store)
app.use(CoreuiVue)
app.component('CFormSelect', CFormSelectUrut) // @change membaca nilai v-model yang baru
app.provide('icons', icons)
app.component('CIcon', CIcon)

// Pengaturan perusahaan, akses menu, dan branding dimuat dulu: halaman pertama memakai nilai dari database,
// dan router baru berjalan setelah akses menu diketahui agar menu modul tidak terlempar ke beranda saat di-reload
const isLogin = JSON.parse(localStorage.getItem('authenticated'))
;Promise.all([siapkanBranding(), ...(isLogin ? [loadPengaturan(), loadMenuAkses()] : [])]).finally(() => {
  app.use(router)
  app.mount('#app')
})

const firebaseConfig = {
  apiKey: 'AIzaSyD2y0uylVf92WvBm105xhI9i11WhsF9koU',
  authDomain: 'webapps-47f3f.firebaseapp.com',
  projectId: 'webapps-47f3f',
  storageBucket: 'webapps-47f3f.appspot.com',
  messagingSenderId: '736931850508',
  appId: '1:736931850508:web:c7cbbb0d0e53b63ce10129',
  measurementId: 'G-31ZCKEY057',
}

initializeApp(firebaseConfig)

// Push notification hanya di browser yang mendukung (butuh HTTPS/localhost, service worker,
// dan Push API). Browser lain tetap bisa memakai aplikasi tanpa notifikasi.
isSupported()
  .then((supported) => {
    if (supported) initMessaging()
    else console.log('Firebase Messaging tidak didukung browser ini, notifikasi dinonaktifkan.')
  })
  .catch((err) => console.log('Gagal memeriksa dukungan Firebase Messaging. ', err))

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
function initMessaging() {
  const messaging = getMessaging()
  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload)
    swal({
      title: 'Info',
      text: payload.notification.body,
      icon: 'info',
    })
  })

  getToken(messaging, {
    vapidKey:
      'BHCsFsoFGtmG_QK5asHsnZHF0RZebBSuJDZLcIYpw88Xb4Mnr1C0rcE88BhP-_cZIMr4PItXKWsl6srKkYVBSlg',
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log('Token is:', currentToken)
        localStorage.setItem('tokenFCM', currentToken)
      } else {
        swal({
          title: 'Info',
          text: 'Tolong Aktifkan Notifikasi Browser Anda',
          icon: 'info',
        })
        console.log('No registration token available. Request permission to generate one.')
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err)
    })
}
